
class ValidationError {
  constructor(serverResponse) {
    this.path = serverResponse.path;
    this.messages = serverResponse.messages;
    this.errors = serverResponse.errors;
  }
}

class OptimisticLockingError {
}

export {ValidationError, OptimisticLockingError};